import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import SimpleReactValidator from 'simple-react-validator';
import { setUser } from '../../redux/actions/user.actions';
import logo from '../../assets/images/Lovrican-Logo-Icon.svg';
import privatelock from '../../assets/images/private_lock.svg';
import { authCall } from '../../services';
import authService from '../../services/authServices';

/* eslint-disable */
function isValidSocialProfileUrl(url, platform) {
  const patterns = {
    facebook: /^(https?:\/\/)?(www\.)?facebook\.com\/[A-Za-z0-9.\-]+\/?$/,
    instagram: /^(https?:\/\/)?(www\.)?instagram\.com\/[A-Za-z0-9._]+\/?$/,
    // snapchat: /^https?:\/\/(www\.)?snapchat\.com\/add\/[A-Za-z0-9._-]+\/?$/,
    // tiktok: /^https?:\/\/(www\.)?tiktok\.com\/@[\w.-]+\/?$/,
    // whatsapp: /^https?:\/\/wa\.me\/\d+\/?$/,
    // youtube: /^https?:\/\/(www\.)?(youtube\.com\/(c|channel|user)\/[\w-]+|youtube\.com\/@[\w.-]+)\/?$/,
    // pinterest: /^https?:\/\/(www\.)?pinterest\.[a-z.]+\/[A-Za-z0-9._-]+\/?$/,
    // reddit: /^https?:\/\/(www\.)?reddit\.com\/user\/[A-Za-z0-9_-]+\/?$/,
    // telegram: /^https?:\/\/(t\.me|telegram\.me)\/[A-Za-z0-9_]+\/?$/,
    // wechat: /^https?:\/\/(www\.)?wechat\.com\/[A-Za-z0-9_-]+\/?$/,
    // x: /^https?:\/\/(www\.)?(x\.com|twitter\.com)\/[A-Za-z0-9_]+\/?$/,
    // messenger: /^https?:\/\/m\.me\/[A-Za-z0-9.]+\/?$/,
    // discord: /^https?:\/\/(www\.)?discord(app)?\.com\/users\/\d+\/?$/,
    // twitch: /^https?:\/\/(www\.)?twitch\.tv\/[A-Za-z0-9_]+\/?$/,
    // douyin: /^https?:\/\/(www\.)?douyin\.com\/user\/[A-Za-z0-9]+\/?$/,
    // qq: /^https?:\/\/(www\.)?qq\.com\/[A-Za-z0-9]+\/?$/,
    // tumblr: /^https?:\/\/[A-Za-z0-9-]+\.tumblr\.com\/?$/
  };
  return patterns[platform].test(url);
}
/* eslint-enable */

const Step15Sub2Component = ({ userDetails }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({
    linkedInURL: userDetails?.linkedin_URL ? userDetails?.linkedin_URL : '',
    linkedInHelp: false,
    isLinkedinDisabled: false,
    selectedMediaPlatform: 'instagram',
    selectedMediaPlatformUrl: '',
    mediaPlatformError: '',
    mediaPlatformHelp: false
  });


  const [validator] = useState(
    new SimpleReactValidator({
      validators: {
        optional: {
          message: 'Optional message',
          rule: () => true,
          required: false // optional
        },
        linkedInURL: {
          message: 'Invalid linkedIn URL.',
          rule: val => {
            const linkedInRegex = /^(https?:\/\/)?(www\.)?linkedin\.com\/(in|company)\/[a-zA-Z0-9-]+\/?$/;
            return linkedInRegex.test(val);
          },
          required: true // optional
        }
      }
    })
  );

  const submitForm = async () => {
    if (values.isLinkedinDisabled && values.selectedMediaPlatformUrl === '') {
      const mediaPlatformError = `Please enter ${values.selectedMediaPlatform} profile url.`;
      setValues({ ...values, mediaPlatformError });
    } else if (values.isLinkedinDisabled && !isValidSocialProfileUrl(values.selectedMediaPlatformUrl, values.selectedMediaPlatform)) {
      const mediaPlatformError = `Invalid ${values.selectedMediaPlatform} profile url.`;
      setValues({ ...values, mediaPlatformError });
    } else if (validator.allValid()) {
      const formData = {
        linkedin_URL: (values.isLinkedinDisabled ? values.selectedMediaPlatformUrl : values.linkedInURL),
        isProfileComplted: 'YES'
      };
      setLoading(true);
      const resp = await authCall('auth/register-section', formData);
      if (resp && resp.success === true) {
        dispatch(setUser(resp.data.user));
        // handleNext(step);
        setLoading(false);
        authService.throwBackRevRegister(history);
      }
      setLoading(false);
    } else {
      validator.showMessages();
      setValues({ ...values });
    }
  };

  const haveLinkedAccountClickHandler = evt => setValues(prev => ({ ...prev, linkedInURL: '', isLinkedinDisabled: evt.target.checked }));

  return (
    <>
      <section className="registerDetails section-one lattest-reg-screen">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              <div className="logo cursor-pointer" role="button" tabIndex="0">
                <img src={logo} className="img-fluid" alt="Lovrican Logo" />
              </div>
            </div>
            <div className="col-12 text-center">
              <div className="progress">
                <div className="progress-bar step15" />
              </div>
            </div>
          </div>

          <div className="row join-reg top-join">
            <div className="col-md-12 col-lg-12">
              <div className="subtitle">
                Complete the final step to help verify authenticity on
                Lovrican. Your information remains confidential
              </div>
            </div>
          </div>
          <div className="row join-reg bottom-join inner_bottom">
            <div className="col-md-12 col-lg-12 pb-2 custome_select private_wrapper">
              <input
                type="text"
                name="user-linkedIn_URL"
                id="user-linkedIn_URL"
                placeholder='Your LinkedIn Profile Link'
                autoComplete="off"
                className="custom_input"
                value={values.linkedInURL}
                onChange={(e) => setValues({ ...values, linkedInURL: e.target.value })}
                disabled={values.isLinkedinDisabled}
              />
              <div className='social-media-hint'>e.g., www.linkedin.com/[in/company]/[username]</div>

              {validator.message(
                'linkedIn url',
                values.linkedInURL,
                `${values.isLinkedinDisabled ? 'optional' : 'linkedInURL|required'}`
              )}
              <div className="text-right">
                <div
                  className="private_btn"
                  aria-hidden="true"
                  onClick={() => {
                    setValues({
                      ...values,
                      linkedInHelp: true,
                    });
                  }}
                >
                  Private
                  <img
                    src={privatelock}
                    className="lock_private"
                    alt="Lock"
                    aria-hidden="true"
                  />
                </div>
              </div>
              {values.linkedInHelp && (
                <div className="toolTipHelp d-flex">
                  <p>
                    This information is private and never shared with anyone.
                    Lovrican uses this information to ensure all members meet
                    the high standards our members expect.
                  </p>
                  <div className="ml-3">
                    <i
                      className="fa fa-times cursor-pointer"
                      aria-hidden="true"
                      onClick={() =>
                        setValues({
                          ...values,
                          linkedInHelp: false
                        })
                      }
                    />
                  </div>
                </div>
              )}
            </div>

            <div className="col-md-12 col-lg-12 mb-3">
              <div className='reg_custom_checkbox'>
                <label className="custom-checkbox">
                  <input
                    type="checkbox"
                    id="haveLinkedinAccountCheckbox"
                    checked={values.isLinkedinDisabled}
                    onChange={haveLinkedAccountClickHandler}
                  />
                  <span htmlFor="haveLinkedinAccountCheckbox" className="checkmark" />
                  I don’t have a LinkedIn account
                </label>
              </div>
            </div>

            {values.isLinkedinDisabled && (
              <>
                <div className="col-md-12 col-lg-12 pb-4 custome_select private_wrapper noLinkAccountWrapper">
                  <div className='heading' htmlFor="#">Provide your profile URL on any of these social media platforms</div>

                  <div className="customeRadio_Inner">
                    <div className="form-group">
                      <div className="form-check">
                        <input
                          className=""
                          type="radio"
                          name="media_platform"
                          id="instagram"
                          value="instagram"
                          checked={values.selectedMediaPlatform === 'instagram'}
                          onChange={() => setValues({ ...values, selectedMediaPlatform: 'instagram' })}
                        />
                        <label htmlFor="instagram">Instagram</label>
                      </div>
                    </div>
                    <div className="form-group">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="media_platform"
                          id="facebook"
                          value="facebook"
                          checked={values.selectedMediaPlatform === 'facebook'}
                          onChange={() => setValues({ ...values, selectedMediaPlatform: 'facebook' })}
                        />
                        <label className="form-check-label" htmlFor="facebook">Facebook</label>
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-md-12 col-lg-12 pb-2 custome_select private_wrapper'>
                      <input
                        type="text"
                        name="user-media-platform"
                        id="user-media-platform"
                        placeholder={`Enter your ${values.selectedMediaPlatform} Profile URL`}
                        autoComplete="off"
                        className="custom_input"
                        value={values.selectedMediaPlatformUrl}
                        onChange={(e) => setValues({ ...values, selectedMediaPlatformUrl: e.target.value })}
                      />
                      <div className='social-media-hint'>e.g., www.{values.selectedMediaPlatform}.com/[username]</div>

                      {values.mediaPlatformError && (<div className="srv-validation-message">{values.mediaPlatformError}</div>)}
                      <div className="text-right">
                        <div
                          className="private_btn"
                          aria-hidden="true"
                          onClick={() => {
                            setValues({
                              ...values,
                              mediaPlatformHelp: true,
                            });
                          }}
                        >
                          Private
                          <img
                            src={privatelock}
                            className="lock_private"
                            alt="Lock"
                            aria-hidden="true"
                          />
                        </div>
                      </div>
                      {values.mediaPlatformHelp && (
                        <div className="toolTipHelp d-flex">
                          <p>
                            This information is private and never shared with anyone.
                            Lovrican uses this information to ensure all members meet
                            the high standards our members expect.
                          </p>
                          <div className="ml-3">
                            <i
                              className="fa fa-times cursor-pointer"
                              aria-hidden="true"
                              onClick={() =>
                                setValues({
                                  ...values,
                                  mediaPlatformHelp: false
                                })
                              }
                            />
                          </div>
                        </div>
                      )}
                    </div>

                  </div>

                </div>
              </>
            )}

            {/* Submit Button */}
            <div className="col-md-12 col-lg-12 mb-3  marb7 text-right">
              <button
                className={`new_next_btn metMaches_btn ${loading ? 'hks-btn-disable' : ''
                  }`}
                onClick={submitForm}
                onKeyDown={(event) => event.key === 'Enter' && submitForm()}
                type="button"
                tabIndex="0"
                disabled={loading || false}
              >
                {userDetails?.is_affiliate === 1 ? "Complete" : "Meet Matches"}
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Step15Sub2Component;
